import isFeatureEnabled from './isFeatureEnabled';

export function areMessageExtensionsEnabledOnReadRibbon(): boolean {
    return (
        isFeatureEnabled('mos-ribbonSurfaceAppCache') &&
        isFeatureEnabled('mos-messageExtensionPinning') &&
        isFeatureEnabled('mos-mos3AppService')
    );
}
